<template>
  <div
    class="sc-status-bar block text-center w-full cursor-pointer"
    :style="styles.wrapper"
  >
    <p
      class="sc-status-text"
      :style="styles.text"
    >
      New messages
      <arrowDownIcon class="w-3 inline-block align-middle ml-2"/>
    </p>
  </div>
</template>

<script>
import arrowDownIcon from '@/assets/images/icons/chat-widget/arrowDownIcon.vue'

export default {
  name: 'ChatStatus',

  components: {
    arrowDownIcon
  },

  props: {
    themeConfig: {
      type: Object,
      required: true
    }
  },

  computed: {
    styles() {
      return {
        wrapper: {
          backgroundColor: this.themeConfig.statusInfo.bg
        },
        text: {
          color: this.themeConfig.statusInfo.text
        }
      }
    }
  }
}
</script>
